import {
  GET_INVOICES_TEMPLATE_LIST,
  SET_INVOICES_TEMPLATE_LIST,
  ADD_INVOICE_TEMPLATE,
  UPDATE_INVOICE_TEMPLATE,
  DELETE_INVOICE_TEMPLATE,
  SET_INVOICE_TEMPLATE_LOADING,
} from "./actionTypes";

export const getInvoiceTemplateList = data => ({
  type: GET_INVOICES_TEMPLATE_LIST,
  payload: data,
});

export const setInvoiceTemplateList = data => ({
  type: SET_INVOICES_TEMPLATE_LIST,
  payload: data,
});

export const addInvoiceTemplate = data => ({
  type: ADD_INVOICE_TEMPLATE,
  payload: data,
});

export const updateInvoiceTemplate = (id, data) => ({
  type: UPDATE_INVOICE_TEMPLATE,
  payload: { id, data },
});

export const deleteInvoiceTemplate = id => ({
  type: DELETE_INVOICE_TEMPLATE,
  payload: id,
});

export const invoiceTemplateLoader = () => ({
  type: SET_INVOICE_TEMPLATE_LOADING,
});
